// extracted by mini-css-extract-plugin
module.exports = {"root":"Chart_root__2RtKA","isAnimated":"Chart_isAnimated__3yc0G","title":"Chart_title__AAZxs","label":"Chart_label__x75w8","date":"Chart_date__3vKHd"};